import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted, onUnmounted, ref } from 'vue';
import appStore from '@/store';

// const route = useRoute();

// watch(
//   () => route,
//   v => {
//     console.log('app router change', v);
//   },
//   { deep: true, immediate: true }
// );


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const baseHeight = ref('100vh');
const _setScale = () => {
  const screenWidth = window.innerWidth;
  const designWidth = screenWidth < 1200 ? 1200 : 1920;
  let scale = 1;

  if (screenWidth >= designWidth) {
    document.body.style.transform = `scale(${scale})`;
    document.body.style.transformOrigin = '0 0';
    document.body.style.width = `${window.innerWidth}px`;
    document.body.style.height = `${window.innerHeight}px`;
    document.body.style.position = 'relative';

    baseHeight.value = '100vh';
  } else {
    scale = screenWidth / designWidth;
    document.body.style.transform = `scale(${scale})`;
    document.body.style.transformOrigin = '0 0';
    document.body.style.width = `${designWidth}px`;
    document.body.style.height = `${window.innerHeight}px`;
    document.body.style.position = 'relative';

    baseHeight.value = `${window.innerHeight / scale}px`;
  }
};

onMounted(() => {
  appStore.useUserStoreSetup.initUserSystemData();

  console.log(document.body.style.width);
  console.log(window.innerWidth);

  // setScale();
  // window.addEventListener('resize', setScale);
});
onUnmounted(() => {
  // window.removeEventListener('resize', setScale);
});

console.log('启动方式：', process.env.NODE_ENV);
console.log('启动环境：', process.env.VUE_APP_SCENE);
console.log('启动版本：', process.env.VUE_APP_VERSION);
console.log('接口域名：', process.env.VUE_APP_PROXY);
console.log('Cors：', process.env.VUE_APP_DOMAIN);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view, {
    class: "router",
    style: _normalizeStyle({ width: '100%', height: baseHeight.value })
  }, null, 8, ["style"]))
}
}

})